<div class="form-wrapper">
  <form [formGroup]="projectExpenditureForm" class="k-form k-d-grid">
    <div class="col">
      <kendo-formfield class="!k-mt-0 !k-mb-0" orientation="horizontal">
        <kendo-label class="!k-align-items-start" [for]="expenditureRateType" text="Aufwand">
        </kendo-label>
        <kendo-dropdownlist
          textField="text"
          valueField="value"
          [showStickyHeader]="false"
          (selectionChange)="expenditureRateOptionChanged($event)"
          [data]="expenditureRateOptions"
          formControlName="expenditureRateType"
          #expenditureRateType
        >
        </kendo-dropdownlist>
      </kendo-formfield>
    </div>

    <div class="col">
      @if (selectedExpenditureRateOption !== ExpenditureRateOptions.ExpendituresInHours) {
        <div class="k-h-full k-d-flex k-align-items-center">
          @if (isExpenditureHourlyValueFixed()) {
            <div class="horizontal-controls k-d-flex k-align-items-center">
              @if (selectedExpenditureRateOption === ExpenditureRateOptions.HourlyRateFixed) {
                {{ expenditureValue | shiveCurrency }}

                <div class="k-d-flex k-align-items-center">
                  <div>&nbsp;pro Stunde</div>
                </div>

                <fa-icon
                  class="edit turquoise icon-button k-display-flex k-align-items-stretch k-ml-3.5"
                  role="button"
                  (click)="openNewExpenditureRateDialog()"
                  size="lg"
                  [icon]="faPenToSquare"
                ></fa-icon>
              }
            </div>
          }
          @if (
            selectedExpenditureRateOption === ExpenditureRateOptions.HourlyRatePerMember ||
            selectedExpenditureRateOption === ExpenditureRateOptions.HourlyRatePerTask
          ) {
            <div class="text-box info k-mt-0 k-d-flex k-align-items-center">
              <div class="custom-symbol notification-info k-mr-2.5"></div>
              Hinweis:
              @if (selectedExpenditureRateOption === ExpenditureRateOptions.HourlyRatePerTask) {
                Bitte die Stundensätze den Aufgaben in der Sektion unten zuweisen.
              }
              @if (selectedExpenditureRateOption === ExpenditureRateOptions.HourlyRatePerMember) {
                Bitte die Stundensätze den Projektmitgliedern in der Sektion unten zuweisen.
              }
            </div>
          }
        </div>
      }
    </div>
  </form>
</div>
